import { useEffect, useState } from "react";
import Button from "../../../../../Custom/Button/Button";
import nextImg from "../../../../../../picture/NextLanguage.png";
import { useGlobalContext } from "../../../../../../Context/Context";

const styles = {
  button: { padding: "10px 20px" },
  input: {
    width: "50%",
    padding: "10px",
    fontSize: "14px",
    marginBottom: "15px",
  },
  title: {
    fontStyle: "italic",
    textDecoration: "underline",
    fontWeight: "bold",
    padding: "2px",
  },
  oblastHeader: {
    padding: "6px 10px",
    backgroundColor: "#d0d0d0",
    fontWeight: "bold",
    fontSize: "14px",
    cursor: "pointer",
    userSelect: "none",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "6px",
  },
  meraRow: {
    display: "flex",
    gap: "7px",
    alignItems: "flex-start",
    padding: "5px 10px",
    borderBottom: "1px solid #eee",
  },
  oblast: {
    padding: "1px 5px",
    border: "1px solid #aaa",
    fontSize: "14px",
    backgroundColor: "#f5f5f5",
  },
};

const Ucitaj = ({ setNewMere, setCurrentState, initialMere, allMere }) => {
  const [grouped, setGrouped] = useState({});
  const [search, setSearch] = useState("");
  const [checked, setChecked] = useState([]);
  const [expandedIds, setExpandedIds] = useState([]);
  const [expandedOblasti, setExpandedOblasti] = useState([]);

  const { dictionary } = useGlobalContext();

  const groupMere = (mere) => {
    return mere.reduce((acc, m) => {
      const o = m.oblast || "Остало";
      if (!acc[o]) acc[o] = [];
      acc[o].push(m);
      return acc;
    }, {});
  };

  useEffect(() => {
    const g = groupMere(allMere);
    setGrouped(g);
    setExpandedOblasti(Object.keys(g));
  }, [allMere]);

  const handleSearchChange = (e) => {
    const val = e.target.value;
    setSearch(val);
    const filtered = val
      ? allMere.filter(
          (m) =>
            m.title.toLowerCase().includes(val.toLowerCase()) ||
            m.text.toLowerCase().includes(val.toLowerCase()) ||
            (m.oblast || "").toLowerCase().includes(val.toLowerCase()),
        )
      : allMere;
    const g = groupMere(filtered);
    setGrouped(g);
    setExpandedOblasti(Object.keys(g));
  };

  const handleChangeChecked = (mera) => {
    setChecked((prev) =>
      prev.find((m) => String(m.id) === String(mera.id))
        ? prev.filter((m) => String(m.id) !== String(mera.id))
        : [...prev, mera],
    );
  };

  const toggleExpand = (id) => {
    setExpandedIds((prev) =>
      prev.includes(id) ? prev.filter((p) => p !== id) : [...prev, id],
    );
  };

  const toggleOblast = (oblast) => {
    setExpandedOblasti((prev) =>
      prev.includes(oblast)
        ? prev.filter((o) => o !== oblast)
        : [...prev, oblast],
    );
  };

  const handleSacuvaj = () => {
    const alreadyIds = initialMere.map((m) => String(m.mera_id));
    const toAdd = checked
      .filter((ch) => !alreadyIds.includes(String(ch.id)))
      .map((ch) => ({
        ...ch,
        id: String(Math.random()),
        mera_id: ch.id,
        text: ch.text,
      }));
    setNewMere((prev) => [...prev, ...toAdd]);
    setCurrentState("");
  };

  const handleReset = () => {
    setChecked([]);
    setSearch("");
    const g = groupMere(allMere);
    setGrouped(g);
    setExpandedOblasti(Object.keys(g));
  };

  const isDisabledSacuvaj = checked.length === 0;

  return (
    <>
      <input
        value={search}
        onChange={handleSearchChange}
        placeholder={dictionary["pretrazi"] || "Pretraži..."}
        style={{...styles.input, width: "100%"}}
      />

      <div style={{ maxHeight: "500px", overflowY: "auto" }}>
        {Object.keys(grouped).length === 0 && (
          <div style={{ color: "#999", padding: "10px" }}>Нема резултата</div>
        )}
        {Object.entries(grouped).map(([oblast, mere]) => (
          <div key={oblast}>
            {/* Oblast header */}
            <div
              style={styles.oblastHeader}
              onClick={() => toggleOblast(oblast)}
            >
              <span>
                {oblast} ({mere.length})
              </span>
              <img
                src={nextImg}
                style={{
                  width: "7px",
                  transform: expandedOblasti.includes(oblast)
                    ? "rotate(-90deg)"
                    : "rotate(90deg)",
                }}
              />
            </div>

            {/* Mere */}
            {expandedOblasti.includes(oblast) &&
              mere.map((mera) => {
                const alreadyAdded = !!initialMere.find(
                  (m) => String(m.mera_id) === String(mera.id),
                );
                const isExpanded = expandedIds.includes(mera.id);

                return (
                  <div key={mera.id} style={styles.meraRow}>
                    <div
                      style={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                        paddingTop: "2px",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={
                          !!checked.find(
                            (m) => String(m.id) === String(mera.id),
                          ) || alreadyAdded
                        }
                        disabled={alreadyAdded}
                        onChange={() => handleChangeChecked(mera)}
                        style={{ width: "25px", height: "25px" }}
                      />
                    </div>
                    <div>
                      <div onClick={() => toggleExpand(mera.id)} style={{ ...styles.title, cursor: "pointer" }}>
                        {mera.title}
                      </div>
                      {alreadyAdded && (
                        <span
                          style={{
                            fontSize: "14px",
                            color: "#666",
                            fontStyle: "italic",
                          }}
                        >
                          {" "}
                          — већ додато
                        </span>
                      )}
                      
                      {isExpanded && (
                        <div
                          style={{
                            whiteSpace: "pre-line",
                            fontSize: "13px",
                            marginTop: "3px",
                            color: "#333",
                          }}
                        >
                          {mera.text}
                        </div>
                        
                      )}
                       
                    </div>
                  </div>
                );
              })}
          </div>
        ))}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          marginTop: "20px",
        }}
      >
        <div onClick={() => setCurrentState("")} style={{ height: "40px" }}>
          <Button activation={true} style={styles.button}>
            <span style={{ width: "10vw", fontWeight: "bold" }}>
              {dictionary["odustani"]}
            </span>
          </Button>
        </div>
        <div onClick={handleReset} style={{ height: "40px" }}>
          <Button activation={true} style={styles.button}>
            <span style={{ width: "10vw", fontWeight: "bold" }}>
              {dictionary["resetuj"]}
            </span>
          </Button>
        </div>
        <div
          onClick={isDisabledSacuvaj ? undefined : handleSacuvaj}
          style={{ height: "40px", opacity: isDisabledSacuvaj ? 0.5 : 1 }}
        >
          <Button
            isDisabled={isDisabledSacuvaj}
            activation={true}
            style={styles.button}
          >
            <span style={{ width: "10vw", fontWeight: "bold" }}>
              {dictionary["sacuvaj"]}
            </span>
          </Button>
        </div>
      </div>
    </>
  );
};

export default Ucitaj;
